import type { CSSProperties } from 'react';

export const styles = {
    svg: { color: 'rgba(0, 0, 0, 0.6)' } as CSSProperties,
};
